import React, { useEffect } from "react";
import About_Banner from "./about-banner/About_Banner";
import Features from "../home/features/Features";
import Why_Choose from "../home/why-choose/Why_Choose";
import What_Student_Say from "../home/what-student-say/What_Student_Say";
import FAQ from "../home/faq/FAQ";
import Who_We_Are from "./who-we-are/Who_We_Are";
import { useDispatch, useSelector } from "react-redux";
import {
  GetAllaboutbanner,
  GetAllCount,
  GetAllfaq,
  GetAllfeedback,
  GetAllwhoweare,
  GetAllwhychoose,
} from "../../redux/aboutus";

const About_Us = () => {
  const dispatch = useDispatch();
  const banner = useSelector(state => state?.aboutus?.aboutbanner);
  const count = useSelector(state => state?.aboutus?.count);
  const whychoose = useSelector(state => state?.aboutus?.whychoose);
  const faq = useSelector(state => state?.aboutus?.faq);
  const feedback = useSelector(state => state?.aboutus?.feedback);
  const whoweare = useSelector(state => state?.aboutus?.whoweare);

  useEffect(() => {
    dispatch(GetAllaboutbanner());
    dispatch(GetAllCount());
    dispatch(GetAllwhychoose());
    dispatch(GetAllfaq());
    dispatch(GetAllfeedback());
    dispatch(GetAllwhoweare());
  }, [dispatch]);
  return (
    <>
      {/* <About_Banner banner={banner} /> */}
      {/* <Features count={count} /> */}
      {/* <Who_We_Are whoweare={whoweare} />
      <Why_Choose whychoose={whychoose} />
      <What_Student_Say feedback={feedback} />
      <FAQ faq={faq} /> */}
      
      {banner && <About_Banner banner={banner} />}
      {count && count.length > 0 && <Features count={count} />}
      {whoweare && whoweare.length > 0 && <Who_We_Are whoweare={whoweare} />}
      {whychoose && whychoose.length > 0 && (<Why_Choose whychoose={whychoose} />)}
      {feedback && feedback.length > 0 && (<What_Student_Say feedback={feedback} />)}
      {faq && faq.length > 0 && <FAQ faq={faq} />}

    </>
  );
};

export default About_Us;
